<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    src="/img/background.jpg"
    dark
    absolute
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4)`"
        v-bind="props"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-img
          class="mt-2 mb-2"
          width="70%"
          src="/img/kobra-logo-inverse.png"
        />
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <v-list dense nav>
      <template v-for="(item, i) in profile">
        <base-item :key="`item-${i}`" :item="item" />
      </template>
    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children && $auth.check(item.permission)"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else-if="$auth.check(item.permission)"
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({}),

  computed: {
    items() {
      return [
        {
          icon: "mdi-view-dashboard",
          title: "dashboard",
          to: "/"
        },
        {
          icon: "mdi-file-document",
          title: "orders",
          to: "/order",
          permission: "order.create"
        },
        {
          icon: "mdi-account-box",
          title: "Kunden",
          to: "/customer",
          permission: "customer.create"
        },
        {
          icon: "mdi-folder",
          title: "Documents",
          to: "/document",
          permission: "document.create"
        },
        {
          icon: "mdi-chart-bar",
          title: "Statistics",
          to: "/statistic",
          permission: "company.create"
        },
        {
          title: "types",
          group: "",
          icon: "mdi-door",
          permission: "doorType.create",
          children: [
            {
              title: "DoorTypes",
              to: "doortype",
              permission: "doorType.create"
            },
            {
              title: "categories",
              to: "typecategory",
              permission: "category.create"
            },
            {
              title: "Frames",
              to: "frame",
              permission: "frame.create"
            },
            {
              title: "Wallconnections",
              to: "wallconnection",
              permission: "wallconnection.create"
            },
            {
              title: "Udtables",
              to: "udtable",
              permission: "udtable.create"
            },
            {
              title: "Rulegroups",
              to: "rulegroup",
              permission: "rulegroup.create"
            },
            {
              title: "Spacer",
              to: "edgeSpacer",
              permission: "edgespacer.create"
            }
          ]
        },
        {
          title: "Labels",
          icon: "mdi-label",
          group: "",
          permission: "labelEntry.create",
          children: [
            {
              title: "LabelEntry",
              to: "labelEntry",
              permission: "labelEntry.index"
            },
            {
              title: "LabelOrder",
              to: "labelOrder",
              permission: "labelOrder.create"
            },
            {
              title: "Labeltypes",
              to: "labeltype",
              permission: "labeltype.create"
            }
          ]
        },
        {
          icon: "mdi-cash",
          title: "Zahlungen",
          to: "/orderPosition",
          permission: "orderPosition.view"
        },
        {
          title: "articles",
          icon: "mdi-layers",
          group: "",
          permission: "item.create",
          children: [
            {
              title: "articles",
              to: "item",
              permission: "item.create"
            },
            {
              title: "article category",
              to: "itemcategory",
              permission: "itemcategory.create"
            },
            {
              title: "suppliers",
              to: "supplier",
              permission: "supplier.create"
            }
          ]
        },
        {
          group: "",
          icon: "mdi-settings",
          title: "settings",
          permission: "company.create",
          children: [
            {
              title: "companies",
              to: "company",
              permission: "company.create"
            },
            {
              title: "Countries",
              to: "country",
              permission: "country.create"
            },
            {
              title: "Numberranges",
              to: "numberrange",
              permission: "numberrange.create"
            }
          ]
        },
        {
          icon: "mdi-account-group",
          title: "usersmanagement",
          group: "",
          permission: "user.create",
          children: [
            {
              title: "users",
              to: "users",
              icon: "mdi-account",
              permission: "user.create"
            },
            {
              title: "roles",
              to: "roles",
              icon: "mdi-account",
              permission: "role.create"
            }
          ]
        }
      ];
    },
    drawer: {
      get() {
        return this.$store.state.modules.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return [
        {
          icon: "mdi-account-circle",
          title: this.$auth.user().name,
          to: "/users/" + this.$auth.user().id
        }
      ];
    }
  },

  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    }
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title)
      };
    }
  }
};
</script>

<style lang="sass">
@import '../../../../../../../node_modules/vuetify/src/styles/tools/rtl'

#core-navigation-drawer
  z-index: 10
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important
    .v-list--nav
      padding-left: 0
      padding-right: 0

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
